<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-card class="elevation-2 mt-5 mb-8">
            <v-card-title class="flex-nowrap">
                Filtrar por fechas
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="processSearch">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuInit"
                                v-model="menuInit"
                                :close-on-content-click="false"
                                :return-value.sync="dateInit"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateInit"
                                    label="Fecha inicial"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateInit"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuInit = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuInit.save(dateInit)"
                                    >
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuEnd"
                                v-model="menuEnd"
                                :close-on-content-click="false"
                                :return-value.sync="dateEnd"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateEnd"
                                    label="Fecha final"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateEnd"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuEnd = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuEnd.save(dateEnd)"
                                    >
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <div class="text-right mt-8">
                        <v-btn
                            color="primary"
                            type="submit"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            color="red"
                            text
                            v-show="(txtSearch !== '') || (dateInit!='') || (dateEnd!='')"
                            @click="cleanSearch"
                        >
                            Limpiar
                        </v-btn>
                    </div>
                </form>
            </v-card-text>
        </v-card>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Lista de reservas
                <v-spacer></v-spacer>
                <v-btn @click="scroll_left" fab small>
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn @click="scroll_right" fab small>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Número</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='number', getListReservations()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='number', getListReservations()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtNumber"
                                                    label="Número"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('number')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            Acciones
                        </th>
                        <th class="text-left" style="min-width:150px">
                            <div class="d-flex align-center">
                                <span>Fecha y hora</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='day', getListReservations()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='day', getListReservations()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtFecha"
                                                    label="Fecha"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="date"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('fecha')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Cliente</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='full_name', getListReservations()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='full_name', getListReservations()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSearch"
                                                    label="Cliente"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txt')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Celular</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='phone_number', getListReservations()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='phone_number', getListReservations()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtPhone"
                                                    label="Celular"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('phone')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-right blue-grey lighten-4" style="min-width:200px">
                            Servicio
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listOrders" :key="index">
                        <td>{{ item.number }}</td>
                        <td>
                            <div class="d-flex">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/service/${item.id}`"
                                        >
                                            <v-icon color="grey">
                                                mdi-eye
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ver</span>
                                </v-tooltip>
                            </div>
                        </td>
                        <td>{{ item.date }} - {{ item.time }}</td>
                        <td>{{ item.full_name }}</td>
                        <td>{{ item.phone_number }}</td>
                        <td class="blue-grey lighten-4 text-right">{{ item.product?.name }} <div v-html="item.product?.description"></div></td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            loading2: false,
            breadcrumbs: [
                {
                    text: 'Reservas',
                    disabled: false,
                    href: '/admin/reservations',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/',
            // list data
            listOrders: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            txtNumber: '',
            txtPhone: '',
            txtFecha: '',
            // export
            menuInit: false,
            menuEnd: false,
            dateInit: '',
            dateEnd: '',
            orderType: 'DESC',
            orderBy: 'created_at'
        }
    },
    props: ['money'],
    mounted() {
        this.getListReservations()
    },
    methods: {
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListReservations()
        },
        changePage (event) {
            this.page = event;
            this.getListReservations()
        },
        cleanSearch (type='') {
            if (type=='') {
                if ( (this.txtSearch !== '') || (this.dateInit!='') || (this.dateEnd!='') ) {
                    this.listOrders = []
                    this.page = 1
                    this.txtSearch = ''
                    this.dateInit = ''
                    this.dateEnd = ''
                    this.getListReservations();
                }
            } else {
                switch (type) {
                    case 'txt':
                        this.txtSearch = ''
                        this.getListReservations();
                        break;
                    case 'phone':
                        this.txtPhone = ''
                        this.getListReservations();
                        break;
                    case 'number':
                        this.txtNumber = ''
                        this.getListReservations();
                        break;
                    case 'fecha':
                        this.txtFecha = ''
                        this.getListReservations();
                        break;
                    default:
                        break;
                }
            }
        },
        async getListReservations () {
            this.listOrders = []
            this.overlay = true
            await axios.post(`/admin/list-reservations?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &search=${this.txtSearch}
                            &date_init=${this.dateInit}
                            &date_end=${this.dateEnd}
                            &number=${this.txtNumber}
                            &phone=${this.txtPhone}
                            &fecha=${this.txtFecha}
            `, {})
            .then(response => {
                // console.log(response)
                response.data.data.forEach(element => {
                    const d = new Date(element.day)
                    element.date = (d.getDate()+1) +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear()
                    this.listOrders.push(element)
                });
                // this.listOrders = response.data[0].data
                this.totalPage = response.data.last_page
                this.pageTable = `Mostrando <strong>${response.data.from??0} - ${response.data.to??0}</strong> de un total de <strong>${response.data.total}</strong>`

                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
        /**
         * scroll
         */
        scroll_left() {
        let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft -= 100;
        },
        scroll_right() {
            let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft += 100;
        },
    },
}
</script>
